import { Box, Fade, Grid, Modal } from "@material-ui/core";
import axios from "axios";
import { filter, isEmpty, isNull, isUndefined, round } from "lodash";
import "rc-slider/assets/index.css";
import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { Button, Card, CardBody, CardSubtitle, CardText, CardTitle } from "reactstrap";
import logo from "../components/imgs/logo.png";
import moment from "moment";
import "./resultStyles.css";

export default class ResultCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetchingIndivdiualWorship: false,
      isFetchingCorporateWorship: false,
      isFetchingPrayer: false,
      isFetchingBible: false,
      isFetchingInternalService: false,
      isFetchingExternalService: false,
      isFetchingRelationships: false,
      isFetchingTithing: false,
      isFetchingSharingFaith: false,
      individualWorship: "",
      corporateWorship: "",
      prayer: "",
      bible: "",
      internalService: "",
      externalService: "",
      relationships: "",
      tithing: "",
      sharingFaith: "",
      overallScore: 0,
      headerIntro: "",
      footerIntro: "",

      date: moment(props.location.state.date_completed).format("YYYY-MM-DD"),
      time: moment(props.location.state.date_completed).format("h:mm a"),
      name: "",

      openModal: false,
      email: "",

      user_email: "",
      user_id: "",
      sentCCEmailModal: false,
    };

    //this.url = "http://localhost:33333";
    this.url = `${process.env.REACT_APP_API_IP}`;
  }
  componentDidMount = () => {
    let result = this.props.location.state.result;
    this.getFeedbackMessage(result);
    this.saveAssessment();
    let stateapp = localStorage["appState"];
    let AppStateCall = JSON.parse(stateapp);
    this.setState({
      name: AppStateCall.first_name + " " + AppStateCall.last_name,
      user_email: AppStateCall.email,
    });
    var name = document.getElementById("html").value;
  };

  componentDidUpdate() {
    window.onpopstate = (e) => {
      this.props.history.push("/home");
    };
  }

  convertTime = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };

  getFeedbackMessage(result) {
    let state = localStorage["categories"];
    let categoriesState = JSON.parse(state);

    result.map((key, index) => {
      const options = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
        },
      };
      let category = key.Question_Category;
      let score = key.Score;
      this.setState({ overallScore: this.state.overallScore + score });

      let uri = `${process.env.REACT_APP_API_IP}/assessment/get-feedback`;
      let message = "";
      if (category === "Individual Worship") {
        this.setState({
          isFetchingIndividualWorship: true,
        });
      } else if (category === "Corporate Worship") {
        this.setState({
          isFetchingCorporateWorship: true,
        });
      } else if (category === "Prayer") {
        this.setState({
          isFetchingPrayer: true,
        });
      } else if (category === "Bible Study") {
        this.setState({
          isFetchingBible: true,
        });
      } else if (category === "Service Within The Body Of Christ") {
        this.setState({
          isFetchingInternalService: true,
        });
      } else if (category === "Service Outside The Body Of Christ") {
        this.setState({
          isFetchingExternalService: true,
        });
      } else if (category === "Relationships") {
        this.setState({
          isFetchingRelationships: true,
        });
      } else if (category === "Tithing") {
        this.setState({
          isFetchingTithing: true,
        });
      } else {
        this.setState({
          isFetchingSharingFaith: true,
        });
      }
      let categoryId = categoriesState.find((obj) => obj.Question_Category === category).ID;

      axios
        .post(uri, {
          authToken: this.props.authToken,
          category: categoryId,
          assesmentType: Number(sessionStorage["templateId"]),
          date_completed: moment().format("YYYY-MM-DD hh:mm:ss"),
          score: score,
        })
        .then((response) => {
          if (response.status == 200) {
            let data = response.data;
            message = isEmpty(response.data) ? "" : data[0];
            this.setState({
              headerIntro: isEmpty(response.data) ? "" : data[0].Intro_message,
              footerIntro: isEmpty(response.data) ? "" : data[0].Footer_message,
            });
            if (category === "Individual Worship") {
              this.setState({
                individualWorship: isEmpty(response.data) ? "" : data[0].Feedback_message,
                isFetchingIndividualWorship: false,
              });
            } else if (category === "Corporate Worship") {
              this.setState({
                corporateWorship: isEmpty(response.data) ? "" : data[0].Feedback_message,
                isFetchingCorporateWorship: false,
              });
            } else if (category === "Prayer") {
              this.setState({
                prayer: isEmpty(response.data) ? "" : data[0].Feedback_message,
                isFetchingPrayer: false,
              });
            } else if (category === "Bible Study") {
              this.setState({
                bible: isEmpty(response.data) ? "" : data[0].Feedback_message,
                isFetchingBible: false,
              });
            } else if (category === "Service Within The Body Of Christ") {
              this.setState({
                internalService: isEmpty(response.data) ? "" : data[0].Feedback_message,
                isFetchingInternalService: false,
              });
            } else if (category === "Service Outside The Body Of Christ") {
              this.setState({
                externalService: isEmpty(response.data) ? "" : data[0].Feedback_message,
                isFetchingExternalService: false,
              });
            } else if (category === "Relationships") {
              this.setState({
                relationships: isEmpty(response.data) ? "" : data[0].Feedback_message,
                isFetchingRelationships: false,
              });
            } else if (category === "Tithing") {
              this.setState({
                tithing: isEmpty(response.data) ? "" : data[0].Feedback_message,
                isFetchingTithing: false,
              });
            } else {
              this.setState({
                sharingFaith: isEmpty(response.data) ? "" : data[0].Feedback_message,
                isFetchingSharingFaith: false,
              });
            }
          }
        });
    });
  }

  saveAssessment() {
    let uri = this.url + "/assessment/";
    let result = this.props.location.state.result;
    const options = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
      },
    };
    let state = localStorage["appState"];
    let AppState = JSON.parse(state);
    const postData = {
      authToken: this.props.authToken,
      date_completed: moment().format("YYYY-MM-DD hh:mm:ss"),
      user_id: AppState.user,
      email: AppState.email,
      template: sessionStorage["templateId"],
      status: "completed",
      assessment_id: this.props.location.state.assessment_Id,
    };

    axios.put(uri, postData, options).then((response) => {
      if (response.status == 200) {
        //alert('Assessment Saved')
      }
    });
  }

  handleOpenModal = () => {
    var name = document.getElementById("html");

    this.setState({
      openModal: true,
    });

    let stateapp = localStorage["appState"];
    let AppStateCall = JSON.parse(stateapp);
    this.sendReportToMail(AppStateCall.email, "user-email");

    //return;

    let uri = this.url + "/profile/getCCEmail";

    axios
      .post(uri, {
        user_id: AppStateCall.user,
        authToken: this.props.authToken,
      })
      .then((response) => {
        let resp = response.data.data;
        if (response.data.data.cc_email != null) {
          this.setState({
            email: response.data.data.cc_email,
          });
        }
      })
      .catch((resp) => {});
  };

  sendReportToMail = (email, sendTo) => {
    let uri = this.url + "/profile/sendReport";

    var htmlText = document.getElementById("html");

    let template = sessionStorage["templateId"];

    let stateapp = localStorage["appState"];
    let AppStateCall = JSON.parse(stateapp);

    const postData = {
      authToken: this.props.authToken,
      email: email,
      spouse_user_id: AppStateCall.spouse_user_id,
      template: sessionStorage["templateId"],
      htmlText: htmlText.outerHTML,
      sendTo: sendTo,
    };

    axios
      .post(uri, postData)

      .then((response) => {})
      .catch((resp) => {});
  };

  handleCloseModal = () => {
    this.setState({
      openModal: false,
      sentCCEmailModal: false,
    });
  };

  onChangeEmail = (e) => {
    this.setState({
      email: e.target.value,
    });
  };

  onSendClicked = () => {
    this.setState({
      sentCCEmailModal: true,
    });
  };

  onSendCCEmailClicked = () => {
    this.setState({
      openModal: false,
      sentCCEmailModal: false,
    });

    this.sendReportToMail(this.state.email, "cc-email");

    let uri = this.url + "/profile/setCCEmailUser";

    let stateapp = localStorage["appState"];
    let AppStateCall = JSON.parse(stateapp);

    const postData = {
      authToken: this.props.authToken,
      user_id: AppStateCall.user,
      cc_email: this.state.email,
    };

    axios
      .put(uri, postData)

      .then((response) => {})
      .catch((resp) => {});
  };

  render() {
    let stateapp = localStorage["appState"];
    let AppStateCall = JSON.parse(stateapp);

    let domains = JSON.parse(localStorage["domainState"]).domains;

    let resultCalculations = this.props.location.state.result;

    function handleDomains(result) {
      let menuItems = [];
      var j = 0;
      let dummyResult = result;
      !filter(dummyResult, { Question_Category: "Sharing Faith" }).length > 0 &&
        dummyResult.push({
          Question_Category: "Sharing Faith",
          Score: 0,
          notes: {
            "Sharing Faith": [{ note: null, title: null }],
          },
        });
      let obj = dummyResult;

      for (var i = 0; i < obj.length; i++) {
        j = i + 1;

        menuItems.push(
          <div
            key={"what-" + i}
            style={{
              width: "100%",
            }}
          >
            <Card style={{ width: "50%" }}>
              <CardBody>
                <CardTitle tag="h1" style={{ textAlign: "center" }}>
                  {obj[i].Question_Category}
                </CardTitle>
                <CardSubtitle tag="h5" className="mb-2 text-muted">
                  Score: {isNaN(obj[i].Score) ? 0 : round(obj[i].Score, 2)}
                </CardSubtitle>
                <div style={{ textAlign: "justify" }}>
                  <span>{ReactHtmlParser(getFeedbackMessageReturn(obj[i].Question_Category))}</span>
                  {obj[i].notes[obj[i].Question_Category].map((x, ca) => !isUndefined(x.note) && !isNull(x.note) && x.toDisplay && <span key={"rc1-" + ca}>{ReactHtmlParser(x.note)}</span>)}
                </div>
              </CardBody>
            </Card>
          </div>,
        );
      }
      return menuItems;
    }
    let state = this.state;

    function getFeedbackMessageReturn(category) {
      let resultCalculations = state;
      if (category === "Individual Worship") {
        return state.individualWorship;
      } else if (category === "Corporate Worship") {
        return state.corporateWorship;
      } else if (category === "Prayer") {
        return resultCalculations.prayer;
      } else if (category === "Bible Study") {
        return resultCalculations.bible;
      } else if (category === "Service Within The Body Of Christ") {
        return resultCalculations.internalService;
      } else if (category === "Service Outside The Body Of Christ") {
        return resultCalculations.externalService;
      } else if (category === "Relationships") {
        return resultCalculations.relationships;
      } else if (category === "Tithing") {
        return resultCalculations.tithing;
      } else {
        return resultCalculations.sharingFaith;
      }
    }

    let result = this.props.location.state.result;
    return this.state.isFetchingIndividualWorship || this.state.isFetchingCorporateWorship || this.state.isFetchingPrayer || this.state.isFetchingBible || this.state.isFetchingInternalService || this.state.isFetchingExternalService || this.state.isFetchingRelationships || this.state.isFetchingTithing || this.state.isFetchingSharingFaith ? (
      <div style={{ marginLeft: "400px" }}>
        <ClipLoader size={300} color={"#123abc"} loading={true} />
      </div>
    ) : (
      <div>
        <header className="page-header">
          <div className="container-fluid">
            <div className="nav-wrapper">
              <div className="main-header">
                <div className="brand-holder">
                  <img src={logo} alt="" />
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="height">
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 25,
            }}
            open={this.state.openModal}
            onClose={this.handleCloseModal}
            closeAfterTransition
          >
            <Fade in={this.state.openModal}>
              <Grid
                item
                style={{
                  width: "30%",
                  boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.75)",
                  overflowY: "auto",
                  overflowX: "hidden",
                  backgroundColor: "white",
                  height: 300,
                }}
              >
                <Grid container direction="row" justify="space-around" alignItems="center" style={{ backgroundColor: "lightyellow" }}></Grid>

                {this.state.sentCCEmailModal === false ? (
                  <Box bgcolor="white">
                    <p
                      style={{
                        width: "94%",
                        marginTop: "10%",
                        marginLeft: "3%",
                      }}
                    >
                      The feedback report has been emailed to you at <span style={{ color: "blue" }}> {this.state.user_email}.</span> If you would like to send a copy of the report to someone else, enter their email address and click send.
                    </p>

                    <form>
                      <div
                        className=""
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          marginTop: "5%",
                          marginLeft: "5%",
                          alignItems: "center",
                        }}
                      >
                        <label style={{}}>CC Email</label>

                        <div className="" style={{ width: "60%" }}>
                          <input
                            type="email"
                            style={{
                              height: 51,
                              width: "100%",
                              backgroundColor: "#f2f4f3",
                              border: "1px solid #dedfdf",
                              borderRadius: 0,
                              marginLeft: "5%",
                            }}
                            required
                            value={this.state.email}
                            onChange={this.onChangeEmail}
                          />
                        </div>
                      </div>
                    </form>

                    <div
                      style={{
                        marginTop: "7%",
                        flexDirection: "row",
                        textAlign: "center",
                        marginLeft: "5%",
                      }}
                    >
                      <Button variant="contained" className={"btn cta-form"} onClick={this.handleCloseModal} style={{ marginRight: "15px", width: "120px" }}>
                        Cancel
                      </Button>
                      <Button variant="contained" className={"btn cta-form"} onClick={this.onSendCCEmailClicked} style={{ marginRight: "15px", width: "120px" }}>
                        Send
                      </Button>
                    </div>
                  </Box>
                ) : (
                  <Box bgcolor="white">
                    <form>
                      <div className="form-group" style={{ display: "flex", flexDirection: "row" }}>
                        <label style={{ marginTop: "10%" }}>CC Email</label>

                        <div className="form-field">
                          <input
                            type="email"
                            style={{
                              height: 51,
                              width: "60%",
                              backgroundColor: "#f2f4f3",
                              border: "1px solid #dedfdf",
                              borderRadius: 0,
                              marginLeft: "10%",
                            }}
                            required
                            value={this.state.email}
                            onChange={this.onChangeEmail}
                          />
                        </div>
                      </div>
                    </form>

                    <div
                      style={{
                        marginTop: "15%",
                        flexDirection: "row",
                        textAlign: "center",
                      }}
                    >
                      <Button variant="contained" className={"btn cta-form"} onClick={this.handleCloseModal} style={{ marginRight: "15px", width: "120px" }}>
                        Cancel
                      </Button>
                      <Button variant="contained" className={"btn cta-form"} onClick={this.onSendCCEmailClicked} style={{ marginRight: "15px", width: "120px" }}>
                        Send
                      </Button>
                    </div>
                  </Box>
                )}
              </Grid>
            </Fade>
          </Modal>

          <div className="assessment-worship-bottom" style={{ paddingTop: "20px", width: "100%", marginLeft: "300px" }}>
            <h3>
              Result{" "}
              <button className="btn btn-small cta-primary prev-btn" style={{ marginLeft: "75px", marginTop: "33px" }} onClick={() => window.print()}>
                Print
              </button>{" "}
              <button className="btn btn-small cta-primary prev-btn" style={{ marginLeft: "15px", marginTop: "33px" }} onClick={this.handleOpenModal}>
                Email
              </button>{" "}
              <button className="btn btn-small cta-primary prev-btn" style={{ marginLeft: "15px", marginTop: "33px" }}>
                {" "}
                <Link
                  to={{
                    pathname: "/home",
                  }}
                  style={{ color: "white" }}
                >
                  Return To Home
                </Link>
              </button>
            </h3>

            <div className="assessment-worship-bottom" id="html" style={{ paddingTop: "20px", width: "100%", color: "black" }}>
              <div style={{ width: "50%", textAlign: "justify" }}>
                <p> Name: {this.state.name}</p>
                <p> Date: {this.state.date}</p>
                <p> Time: {this.state.time}</p>
                <hr
                  style={{
                    height: 1,
                    color: "black",
                    backgroundColor: "black",
                  }}
                ></hr>
              </div>

              <div style={{ width: "50%", textAlign: "justify", marginTop: 50 }}>{ReactHtmlParser(this.state.headerIntro)}</div>

              {handleDomains(result)}
              <div
                style={{
                  width: "50%",
                  textAlign: "justify",
                  paddingTop: "15px",
                }}
              >
                {ReactHtmlParser(this.state.footerIntro)}
              </div>

              <div></div>
            </div>
          </div>
          <footer>
            <div className="container">
              <a href="# ">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAYAAABxlTA0AAAABHNCSVQICAgIfAhkiAAADexJREFUeF7tnXlwFFUawPuaM4GEHBwFAeRyYRMyEyHcRwgJuWcWJcritVol5aq7tQorcujIKoq6tW6Vq4W6a0mtK2YJkBMDSUAIGFgTMkkIchqQkEBmcs/RM9P9tt4MwWTIzHT365kMVeQ/6Pe+975ff/n6+77+XgfH7v/4lQDuV+n3hWP3BOAJC/IUUaPGP4hJqckAYDgGmOa25ksXbtY/aQr2exjkgHVEXFZSmkQ68huCIEIHwmQBa7Lbeh9vKKosxDAdG6yggxiwjojXpGyUSELf9QbPbre8oS+Y/xcMw0AwQg5SwABXaU9toijFDi7QaFtPbkPhkv9yGRvoMUEJWK2pfpOQKLbiGEZwAcIy9tra/XMe4jI20GOCDrBK8/3bpES5iStcCAxgGNt1q2ny5WNrfw40QF/rBRVgtab6HVIi34hhOOlr4+7XaXPbsobSVcf4zvP3+KABrNacepekZK9gOE4JUdpq7pjbWJr0g5C5/pwTFICdlkvJN2I4f8t1ugiW7Wu9enrMjZr1Zn/CEiJ72AFDn0tJFK8KcQv9CjMO27/OHJj7rBAA/p4zjIABrtac0vGJFoaCAVjmut3StqD+YMZ1f8MSIn+YAOsIlTbtVZJSvMUnWnBXELCMwWrqWnm2bIVeiPKBmDMMgHWEWrNqIylRes3QfCkPANth6jYs/7E8pcHX2OG8HmDAgFDlVG+gpMqdKEoDwHbS3YZFjeUp51DkBGJuAAHnkaqcmFdEgNvT19M+8/zh1BuBAIS6RqAA4yptNefagielAAbsLZcvjG87k9uOqnig5gcEsFpbvY2kFNtRlIJwrzWdiGhveqEPRU6g5/odsLNwQym24bjw4j4AbE/LlYvT7iXL7b+RfgWMmqE5szTAdnV3ts65VJlxGdH68Pic4y+TpHItjuPhGIZZWZY+0ms8t/3S8Wf85nL8Bvh2bWGD0PT3NtwOutuwGDVaiEs/tEyqiP4aw4mx7r9JAAMmh936V33B/DcQb+CQ0/0CWBS4LGMw9RhXoMa5cekV6dKQqH04hsk9AwSM3WbdoS+c/7rYkEUHLIpbYB1tlt6e9KbDSXUoCsdlfZchlYcXcckWAWAtvcZzEy8c/a0BZU33uaIChg80kpJvQXELLMvecph60+vLltaiKBqbcTRFrgw/yKeI5LCbP6srWPAcyrr+AoyrtdVbCVLxJlq0wLSb+zrTzpUlo8HNqUqRS0N5wXX6fJa5VrMvYVKQAXYVbri+oPS0eWi51t6uVahuYXbW8WyJbMR+XEBtGQDQVpOvGhc8gNfkkWpbzAbkwg3LGMy9hoXnDqdeRFEOwpXKR+zn4xYGrscC5lJtfsJ0lD2I6CJ0hCpnFXLhBgOgt6vzhho1zo3NqUqRSUIPCrFcV0iIAQfd/Za+eKmokYTAh5xoJUdLt7F1xqWjaMXy2JyjKXIpvweau6UBADpr8lVRGIaJ2iUkADC/phCPhRvAmluuXJyMmv7CUEwmDysU6hZc1gscFrMxp+lg8kEx3QOUxRsw36aQoTYMY86WKxcnIcPNLF8pVUSX4BgmFQoG9lTYLR3r6kuS9giV4W0eL8BCmkLuWhz6XOONWchuIftQqkw2psB7huYdGYRrM3c90VC67D/+gMvLglGaQvo3L1bhJjajPEumiMrDcVwhHAxgbNaex+qLl+4VLsP3TE4WLEZtAca5th7DctTCTWzm4UyZfHQ+jmMy3+p5fAIwNqvpsfriRX6Fy8mCb9cWYFVMUMeN6yHCtFt6ulNRk4hfZ1eskMuiDqL6XIet7yl94aJ/C79B3Gd6tWAxmkKg5VpMHemo6W9c5pGVMsWob1GiBQyDVTPT04GC69WCRYkWWEeb3WTKRC3cxGefzJLIlAdQ4drspsfqC0RwC1/o5LExsTNYAlM4DO3XL+Q+3+LJpoewYB2h1qZtQS7csMxNi6krualsxVnuv1B3j0RNf50uCoZi1u5HUR9o00rzokMjw14jJNQzOEmEuWQDFtgctQ6b9a2GhTmF8ATJQC3cAHNr2/cFTKymkPjsE6mUNKRUaPrbD9dGdz3RUIQWis08tHe6PDL8IEGRUz3p7zCbt+nL/rcD0/1yZmQQYFdWFF7iC6C36zAUo7sNC1GjBVHgAuCw2QxrGopWHkDRaXp5/pQRo0ZW4RTls9Jm6+nJbViiuXOc4Q5geFRq9Ljpt9xP8/DZGHz7293ZmoBauIE+l5IqD6BZLrDTVuOjjcXJ+/no4D52yuEvJ4ZHTjiFk8RYLnJYljVdv/jj2PZcV3vBHcCqjBMqShl6houQocaI1RQiSrQAAGOlDesai1d+I1QfOG/iVx+Pipw14xxBkGP4yGHMlsV1CzJODAasPaWlKLmguy1WU8isrMpkpTyiDCVagA80mjaubSxakccHyl1jd+mUCXMXX8NJMpKvHLuNfqp+btruQYDjNad+I5HI9/EVJlbhJjazMlOmiIRvf5EKN7S185HG4uWCDOWO7hBu4pIbOOGKFPj+2K3Wp+vnpX85GHDOSbVEGsLrXRjscuw2ts5GLtw4awvRe1HSX2coRnfn1hctzecLZNB4RLhQlsNiXaKfn141CPCY2btDxk+Pu0ngRAiXDcJQTIymkNjsilSZNBI+0AQXbiBcMdLfSfm7xkU+MLVBiFvoZwYY1mz6uXnsec2zvYMAw3/EZR/TymRhPn+9YGe5GE0hsRnlKTJldCFKyVGs9Pd2tPADThLRXAzM0xhbb9/jDYuzv+q/fleiMTtn1TapVKnzJACeibCaurJQ2/bF8LkQLm0zr20oXIh0jNYZ50aEn+Aainli47Ba3tNf7duM5eYyHgA7/xuPzzyWSkiVOoKQJOK46zgrAEwPy9h30zbz202lSW0odzk2+3iWXDYCubYgBlyYoSkiw77jkkR405mhrR/UNfduGgj3LhfhLmDq0q9jlKERDwBMau64eaFJjHNosdnfpcplYaWooZgYPndG2d5fhUaFleEUNVGowQDnrxH9sb6554/ucH0CFrqop3mipL8iRQsPVuY9qAyPqCBIcrxQPWGhh7HZPtXPTXvekwxObzSEbmDgvNk5VTkSSeg+tPQXY2mLcU1jyQre8frAvTgLN1HhR1DgYgBjGJvtn3WJq9Z74xMQwNAtyKRhSFUx+BCw0p3rGouTkNLfGRV540NGRVQTJDlBqOFAy2VpO4Trs1HQ74BFaQrBgN1qMTx5tmQl0qt1Z5w7eUoNygPtNtzPfVmutyhC6I29ax4MxeSKiAKkBxoADtra/mhjSQqSW5iQ93lE9PTJFwmCjBCqoPOBZqN3efO57rL9ZsFxWZUZUnkkp+ZnjzE3LNxYDY+glhwxEdJfuEcHTf9Dn5j2Ip8b5BfAzjMRIWO+RcnQnE0hIryJwHTLqQTNthacIEbzAeM+1lOc60umPwATD62ubcEJklOB2tMGGQf9yZkDib/3pYDX6wDg6tqKizhFTsEFtIn1y2as9Ht1V3sGZWhc9yU64NlZxzZKZGE70TrdAW00XpjcfDQXKWOcVZI3VjEhupUrjKHGOayWnXrz6a1Yks4hRI7ogB9aXVuDE2SCkM3csRjGdvrM/rnzUGTAubEV+zbIoka9L1SOw0rv1JurBcOF6/oD8CWc8PzmlYuyALAFNflqLZex3saoaw9/SZDUk0LkOH3umWubsfXr7ULm+y1MS3i49iyBk7NQNsUy9sra/XOSUWTAubOrinZIRoS+xlcOQ9Mf1s2tfgXD0T/ZKLoFqzQnP6IkIS/wVWrgeMAyRmOtfkJz8++sKHJmFu+OVcbEcP5ghzOJsNCf1M1LewnDcVE+1Sg64GlL8qLDRk9vxnFCiQLHTpvW64sWfooiA9u1S5KQOK0Dd/uw6FAyXRka/XldYrrX2gLf/YgOGG4gPufkdolUuRklg2OdHZmGRagnj2Z+uydBMW70SRzDPba7uuDCwk2az9pCUACGm0jQnv4Qp2QvcTnG6mnT8NVUX1974vlDq37iq9jA8XHl+SslEeF7MJKIuCseBsBqt1o/qp+fsRFlDU9z/WLB/YuptKf/RlKyPyBBBmxnX097rAifkCHijhdtpkIVTxA4MRK27DE0XdHXenXT5dXP3/IHXL+Eae4bVWm/30lRyj+jKAAA211TVT4eu7kx6L947a6nXy3YtRjAVZrTf6Ek8i2IkM01VeWj7zXIAQAMscKDi2lvkBIF0ilKAIC57ecrE1tOrzai3KxAzg0QYKjS/c96+f/GrskjVfZJWylK7rHvgssm4KEaswghHJe1UMcE0IL7t5pHqjUTX0d1F2IdC0MF6Gv+MAB2+WSVJn07Sck3I5U1RToH4gsSyvVhAuyKLtTaU+8TlOJPKHEyyzLNFtOthefK0pDqvigQvc0dRsCubYmRjDjs9Gd1BYmip7liQB92wFAJmFYTlPRFobULwLK9N1uPjLn+/csWMaCIKSMoAEOF1Jrqv5OU/AWhX6yiLcY5DSUrasSEI4asoAGM6i5os2FZQ2ny/T/z4Msq1NrqDwhS8TKf6AK+4u/oaJzyU+W6q77kB/p6UFlwv/J8C0Qsa6+v3TcnPtDwuKwXlICdBaL7fyyKy/1DGZNHqrQxWynK83EGKN3hsLxTd2DeFgwT5x0ayo6HmhukFty/VR0Rl5n8sEQe+oX76SfAMmabzfxcQ/GNPRj2y5kIsQGhygtywC71opfnhY4fGROP49RUQLA4a7NfobuMdedPaJxHpYL5554AHMwAfe3tPmBfhBCv/x9V7zCzjAeY1gAAAABJRU5ErkJggg=="
                  alt=""
                />
              </a>
            </div>
          </footer>
        </div>
      </div>
    );
  }
}
